import { render, staticRenderFns } from "./SetupCoupon.vue?vue&type=template&id=34230e1f&scoped=true&"
import script from "./SetupCoupon.vue?vue&type=script&lang=ts&"
export * from "./SetupCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./SetupCoupon.vue?vue&type=style&index=0&id=34230e1f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34230e1f",
  null
  
)

export default component.exports